import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";

document.title = `Magique - Checkout`;
const metaDescription = document.querySelector('meta[name="description"]');
if (metaDescription) {
  metaDescription.setAttribute(
    "content",
    `Transform your body with Sonicfit™ ultrasonic cavitation. Effortlessly target stubborn fat on the stomach, legs, and arms while tightening skin and reducing cellulite—all with a painless, non-invasive treatment.`,
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
